import { GlobalState } from "little-state-machine";
import ISiteDiarySeletionDetails from "interfaces/SiteDiary/ISiteDiarySeletionDetails";

export const updateSiteDiarySelectionDetails = (
  state: GlobalState,
  siteDiary: ISiteDiarySeletionDetails
) => ({
  ...state,
  siteDiary
});
